import { TableRow, TableCell } from '@sanlam-glacier/app-common/components';
import { selectedClientName } from 'stores/dashboard-store/dashboard-store';
import { useSetAtom } from 'jotai';
import { Link } from 'react-router-dom';

type ReportTableProps = {
  row: {
    id: number;
    clientName: string;
    clientSurname: string;
    investmentType: string;
  };
};

export const ClientTableRow = ({ row }: ReportTableProps) => {
  const setClientName = useSetAtom(selectedClientName);

  const handleClientSelection = (clientName: string, clientSurname: string) => {
    setClientName(clientName + ' ' + clientSurname);
  };

  return (
    <TableRow key={row.id}>
      <TableCell align={TableCell.ALIGN.LEFT}>{row.clientName}</TableCell>
      <TableCell align={TableCell.ALIGN.LEFT}>{row.clientSurname}</TableCell>
      <TableCell align={TableCell.ALIGN.LEFT}>{row.investmentType}</TableCell>
      <TableCell>
        <Link
          onClick={() => handleClientSelection(row.clientName, row.clientSurname)}
          to={`/clients/${row.id}`}
        >
          View
        </Link>
      </TableCell>
    </TableRow>
  );
};
